import React from 'react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectLabel,
  SelectGroup,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';

import { AvailableModel } from 'api/prediction-engine';
import { usePredictionsEngineContext } from '../context/PredictionsEngineContext';

interface PredictionModelsDropdownProps {
  label?: string;
  disabled?: boolean;
}

export const PredictionModelsDropdown: React.FC<
  PredictionModelsDropdownProps
> = ({ label = 'Select Model', disabled = false }) => {
  const { availableModels, isLoadingModels, selectedModel, setSelectedModel } =
    usePredictionsEngineContext();

  const handleModelSelect = (modelId: string) => {
    const model = availableModels.find(
      (m) => m.id === modelId,
    ) as AvailableModel;
    setSelectedModel(model);
  };

  const getModelDisplayName = (model: AvailableModel) => {
    return `${model.is_organization_model ? 'Private' : 'System'} ${model.algo_version} - ${model.data_version}${model.limited_cast ? ' (Limited)' : ''}`;
  };

  const displayValue = selectedModel
    ? getModelDisplayName(selectedModel)
    : 'Select a model';

  const isDisabled = disabled || isLoadingModels;

  return (
    <div className="tw-flex tw-flex-row tw-gap-2">
      <Label className={`mb-0 ${isDisabled ? 'tw-opacity-60' : ''}`}>{label}</Label>
      <Select value={selectedModel?.id} onValueChange={handleModelSelect} disabled={isDisabled}>
        <SelectTrigger
          disabled={isDisabled}
          className={isDisabled ? 'tw-opacity-60 tw-cursor-not-allowed' : ''}
        >
          <SelectValue>{displayValue}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel>Models</SelectLabel>
            {availableModels.map((model) => (
              <SelectItem key={model.id} value={model.id}>
                {getModelDisplayName(model)}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};
